/**
 * Normalize user_type from Redux / localStorage to a lowercase string.
 */
export function normalizeUserType(userType) {
  if (userType == null || userType === "") return null;
  if (Array.isArray(userType)) {
    return userType.join("").toLowerCase();
  }
  return String(userType).toLowerCase();
}

/**
 * Investor module access: investors and cooperative members may use /invest/*.
 */
export function canAccessInvestorModule(userType) {
  const type = normalizeUserType(userType);
  return type === "investor" || type === "member";
}

/**
 * Cooperative member module access: members only (not investors).
 */
export function canAccessMemberModule(userType) {
  return normalizeUserType(userType) === "member";
}

/**
 * Staff/admin users — keep parity with existing auth guard checks.
 */
export function isStaffUserType(userType) {
  const type = normalizeUserType(userType);
  if (!type) return false;
  return type.includes("staff");
}

export function isInvestorPath(pathname) {
  if (!pathname) return false;
  const path = pathname.replace(/\/$/, "") || "/";
  return path === "/invest" || path.startsWith("/invest/");
}

export function isInvestorPublicPath(pathname) {
  const path = pathname.replace(/\/$/, "") || "/";
  return (
    path === "/invest/login" ||
    path === "/invest/signup" ||
    path === "/invest/payment/confirmation" ||
    path.startsWith("/invest/payment/confirmation") ||
    path === "/invest/marketplace/payment/confirmation" ||
    path.startsWith("/invest/marketplace/payment/confirmation")
  );
}

/**
 * Staff preview of investor-facing detail pages via ?preview=staff.
 * Requires ?preview=staff and an authenticated staff session.
 */
export function isInvestorStaffPreviewPath(pathname, search = "") {
  const path = pathname.replace(/\/$/, "") || "/";
  const raw = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(raw);
  if (params.get("preview") !== "staff") return false;

  return (
    /^\/invest\/investments\/[^/]+$/.test(path) ||
    /^\/invest\/marketplace\/[^/]+$/.test(path)
  );
}

export function isMemberAreaPath(pathname) {
  if (!pathname) return false;
  const path = pathname.replace(/\/$/, "") || "/";
  if (path === "/member-signup") return false;
  return path.startsWith("/member/");
}
